import { cn } from '@/lib/cn';

/** Facturita app icon (public/logo.svg, 1024×1024). Square; rounded to match the app-icon shape. */
export function LogoMark({ size = 30, className }: { size?: number; className?: string }) {
  return (
    <img
      src="/logo.svg"
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      className={cn('shrink-0 select-none', className)}
      style={{ width: size, height: size, borderRadius: Math.round(size * 0.22) }}
    />
  );
}

export function Logo({ size = 30 }: { size?: number }) {
  return (
    <div className="flex items-center gap-[11px]">
      <LogoMark size={size} />
      <span className="font-display font-bold text-xl tracking-[-0.3px]">Facturita</span>
    </div>
  );
}
